import { useQuery } from "@tanstack/react-query";
import { Appointment } from "@elixir/types";
import getB from "../../utils/bridges/EkaBridge";
import { Timestamp } from "firebase/firestore";
import { getAppointmentActivity } from "apis";

export type FirestoreAppointmentActivityEvent = {
  event: string;
  actor_name: string;
  actor_role: "DOCTOR" | "STAFF";
  created_at: Timestamp;
};

type TActivityIcon = {
  iconType: "far" | "fas";
  iconName:
    | "tag"
    | "circle-check"
    | "calendar"
    | "archive"
    | "circle-exclamation"
    | "person-walking-dashed-line-arrow-right"
    | "stethoscope"
    | "repeat"
    | "circle-xmark"
    | "message-pen";
};

export type TActivityLogStyles = {
  title: string;
  actor: string;
  actorName: string;
  titleStyle: string;
  titleFont: string;
  actorFont: string;
  actorNameFont: string;
  actionIcon: TActivityIcon;
  dayByMonth: string;
  time: string;
  actor_role: "doctor" | "staff";
};

type dataReturnedByAppointmentActivityFS = {
  id: string;
  original: FirestoreAppointmentActivityEvent;
  styled: TActivityLogStyles;
}[];

const useGetAppointmentActivityFromFS = (aid: Appointment["aid"]) => {
  const { data: logStyleData = [], isLoading: isLogDataLoading } = useQuery({
    queryKey: ["appointment-activity-logs", aid],
    queryFn: async () => {
      if (!aid) return [];
      // @ts-ignore
      const data: dataReturnedByAppointmentActivityFS =
        await getB().recordAppointmentActivityInFireStore.getAppointmentActivityLogs(
          aid
        );
      return data;
    },
    enabled: !!aid,
  });

  return {
    logStyleData,
    isLogDataLoading,
  };
};

export default useGetAppointmentActivityFromFS;

export const useGetVendorDataForAppointments = (aid) => {
  return useQuery(["vendor-meta", aid], () => getAppointmentActivity({ aid }), {
    enabled: !!aid,
    refetchOnMount: "always",
    staleTime: 0,
  });
};
